"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var BrandSmtpCfgEditor = /** @class */ (function (_super) {
    __extends(BrandSmtpCfgEditor, _super);
    function BrandSmtpCfgEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandSmtpCfgEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record != null) {
            this.props.data.LoadData(this.props.record.key, function () {
                _this.setState({
                    smtp_server: _this.props.data.DATA.smtp_server,
                    smtp_port: _this.props.data.DATA.smtp_port,
                    smtp_user: _this.props.data.DATA.smtp_user,
                    smtp_password: _this.props.data.DATA.smtp_password,
                    smtp_use_ssl: _this.props.data.DATA.smtp_use_ssl,
                    smtp_from_email: _this.props.data.DATA.smtp_from_email,
                    double_opt_in_via_unisender: _this.props.data.DATA.double_opt_in_via_unisender,
                    unisender_apikey: _this.props.data.DATA.unisender_apikey,
                    is_unisender_add_on_verify_email: _this.props.data.DATA.is_unisender_add_on_verify_email,
                    unisender_verify_email_player_tag: _this.props.data.DATA.unisender_verify_email_player_tag,
                    unisender_verify_email_player_group_id: _this.props.data.DATA.unisender_verify_email_player_group_id,
                    is_unisender_add_on_subscribe_email: _this.props.data.DATA.is_unisender_add_on_subscribe_email,
                    unisender_subscribe_email_player_tag: _this.props.data.DATA.unisender_subscribe_email_player_tag,
                    unisender_subscribe_email_player_group_id: _this.props.data.DATA.unisender_subscribe_email_player_group_id,
                    is_unisender_move_mail_players_to_another_group: _this.props.data.DATA.is_unisender_move_mail_players_to_another_group,
                    unisender_mail_payers_another_group_tag: _this.props.data.DATA.unisender_mail_payers_another_group_tag,
                    unisender_mail_players_another_group_id: _this.props.data.DATA.unisender_mail_players_another_group_id,
                });
            });
        }
        this.setState({
            smtp_server: "",
            smtp_port: 0,
            smtp_user: "",
            smtp_password: "",
            smtp_use_ssl: false,
            smtp_from_email: "",
            double_opt_in_via_unisender: false,
            unisender_apikey: "",
            is_unisender_add_on_verify_email: false,
            unisender_verify_email_player_tag: "",
            unisender_verify_email_player_group_id: 0,
            is_unisender_add_on_subscribe_email: false,
            unisender_subscribe_email_player_tag: "",
            unisender_subscribe_email_player_group_id: 0,
            is_unisender_move_mail_players_to_another_group: false,
            unisender_mail_payers_another_group_tag: "",
            unisender_mail_players_another_group_id: 0,
        });
        this.doReSetRules();
        this.props.state.setExtBreadCrumbPath(["Настройка SMTP бренда"]);
    };
    BrandSmtpCfgEditor.prototype.doReSetRules = function () {
        this.setState({
            smtp_server_rules: { isError: false },
            smtp_port_rules: { isError: false },
            smtp_user_rules: { isError: false },
            smtp_password_rules: { isError: false },
            smtp_from_email_rules: { isError: false },
            unisender_apikey_rules: { isError: false },
            unisender_verify_email_player_tag_rules: { isError: false },
            unisender_verify_email_player_group_id_rules: { isError: false },
            unisender_subscribe_email_player_tag_rules: { isError: false },
            unisender_subscribe_email_player_group_id_rules: { isError: false },
            unisender_mail_payers_another_group_tag_rules: { isError: false },
            unisender_mail_players_another_group_id_rules: { isError: false },
        });
    };
    BrandSmtpCfgEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.smtp_server) || (this.state.smtp_server.length === 0)) {
            this.setState({ smtp_server_rules: { isError: true, errorMessage: "Поле [smtp сервер] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_user) || (this.state.smtp_user.length === 0)) {
            this.setState({ smtp_user_rules: { isError: true, errorMessage: "Поле [Логин пользователя] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_password) || (this.state.smtp_password.length === 0)) {
            this.setState({ smtp_password_rules: { isError: true, errorMessage: "Поле [Пароль пользователя] не заполнено!" } });
            return false;
        }
        if ((!this.state.smtp_port) || (isNaN(this.state.smtp_port))) {
            this.setState({ smtp_port_rules: { isError: true, errorMessage: "Поле [smtp порт] не заполнено!" } });
            return false;
        }
        else {
            if ((this.state.smtp_port < 0) || (this.state.smtp_port > 64000)) {
                this.setState({ smtp_port_rules: { isError: true, errorMessage: "Поле [smtp порт] имеет недопустимое значение" } });
                return false;
            }
        }
        if ((!this.state.smtp_from_email) || (this.state.smtp_from_email.length === 0)) {
            this.setState({ smtp_from_email_rules: { isError: true, errorMessage: "Поле [Адрес отправителя] не заполнено!" } });
            return false;
        }
        if (this.state.double_opt_in_via_unisender) {
            if ((!this.state.unisender_apikey) || (this.state.unisender_apikey.length === 0)) {
                this.setState({ unisender_apikey_rules: { isError: true, errorMessage: "Поле [апи ключ для unisender] не заполнено!" } });
                return false;
            }
            if (this.state.is_unisender_add_on_verify_email) {
                if ((!this.state.unisender_verify_email_player_tag) || (this.state.unisender_verify_email_player_tag.length === 0)) {
                    this.setState({ unisender_verify_email_player_tag_rules: { isError: true, errorMessage: "Поле [тэг тгрока в unisender] не заполнено!" } });
                    return false;
                }
                if ((!this.state.unisender_verify_email_player_group_id) || (isNaN(this.state.unisender_verify_email_player_group_id))) {
                    this.setState({ unisender_verify_email_player_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] не заполнено!" } });
                    return false;
                }
                else {
                    if ((this.state.unisender_verify_email_player_group_id < 0) || (this.state.unisender_verify_email_player_group_id > 64000)) {
                        this.setState({ unisender_verify_email_player_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] имеет недопустимое значение" } });
                        return false;
                    }
                }
            }
            if (this.state.is_unisender_add_on_subscribe_email) {
                if ((!this.state.unisender_subscribe_email_player_tag) || (this.state.unisender_subscribe_email_player_tag.length === 0)) {
                    this.setState({ unisender_subscribe_email_player_tag_rules: { isError: true, errorMessage: "Поле [тэг тгрока в unisender] не заполнено!" } });
                    return false;
                }
                if ((!this.state.unisender_subscribe_email_player_group_id) || (isNaN(this.state.unisender_subscribe_email_player_group_id))) {
                    this.setState({ unisender_subscribe_email_player_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] не заполнено!" } });
                    return false;
                }
                else {
                    if ((this.state.unisender_subscribe_email_player_group_id < 0) || (this.state.unisender_subscribe_email_player_group_id > 64000)) {
                        this.setState({ unisender_subscribe_email_player_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] имеет недопустимое значение" } });
                        return false;
                    }
                }
                if (this.state.is_unisender_move_mail_players_to_another_group) {
                    if ((!this.state.unisender_mail_payers_another_group_tag) || (this.state.unisender_mail_payers_another_group_tag.length === 0)) {
                        this.setState({ unisender_mail_payers_another_group_tag_rules: { isError: true, errorMessage: "Поле [тэг тгрока в unisender] не заполнено!" } });
                        return false;
                    }
                    if ((!this.state.unisender_mail_players_another_group_id) || (isNaN(this.state.unisender_mail_players_another_group_id))) {
                        this.setState({ unisender_mail_players_another_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] не заполнено!" } });
                        return false;
                    }
                    else {
                        if ((this.state.unisender_mail_players_another_group_id < 0) || (this.state.unisender_mail_players_another_group_id > 64000)) {
                            this.setState({ unisender_mail_players_another_group_id_rules: { isError: true, errorMessage: "Поле [группа игрока в unisender] имеет недопустимое значение" } });
                            return false;
                        }
                    }
                }
            }
        }
        return true;
    };
    BrandSmtpCfgEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                brand_id: this.props.record.key,
                smtp_server: this.state.smtp_server,
                smtp_port: this.state.smtp_port,
                smtp_user: this.state.smtp_user,
                smtp_password: this.state.smtp_password,
                smtp_use_ssl: this.state.smtp_use_ssl,
                smtp_from_email: this.state.smtp_from_email,
                double_opt_in_via_unisender: this.state.double_opt_in_via_unisender,
                unisender_apikey: this.state.unisender_apikey,
                is_unisender_add_on_verify_email: this.state.is_unisender_add_on_verify_email,
                unisender_verify_email_player_tag: this.state.unisender_verify_email_player_tag,
                unisender_verify_email_player_group_id: this.state.unisender_verify_email_player_group_id,
                is_unisender_add_on_subscribe_email: this.state.is_unisender_add_on_subscribe_email,
                unisender_subscribe_email_player_tag: this.state.unisender_subscribe_email_player_tag,
                unisender_subscribe_email_player_group_id: this.state.unisender_subscribe_email_player_group_id,
                is_unisender_move_mail_players_to_another_group: this.state.is_unisender_move_mail_players_to_another_group,
                unisender_mail_payers_another_group_tag: this.state.unisender_mail_payers_another_group_tag,
                unisender_mail_players_another_group_id: this.state.unisender_mail_players_another_group_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Настройки SMTP бренда изменены!");
            });
        }
    };
    BrandSmtpCfgEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandSmtpCfgEditor.prototype.getFormTitle = function () {
        return "Изменить настройки SMTP бренда";
    };
    BrandSmtpCfgEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 1000 },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "SMTP сервер:", placeholder: "Введите SMTP сервер" }, value: this.state.smtp_server, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_server: newVal,
                        smtp_server_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_server_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "SMTP порт:", placeholder: "Введите SMTP порт" }, values: { max: 64000, min: 0, value: this.state.smtp_port }, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_port: newVal,
                        smtp_port_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_port_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Логин пользователя:", placeholder: "Введите Логин пользователя" }, value: this.state.smtp_user, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_user: newVal,
                        smtp_user_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_user_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Пароль пользователя:", placeholder: "Введите пароль пользователя" }, value: this.state.smtp_password, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_password: newVal,
                        smtp_password_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_password_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Адрес отправителя:", placeholder: "Введите адрес отправителя" }, value: this.state.smtp_from_email, onValueChanged: function (newVal) {
                    _this.setState({
                        smtp_from_email: newVal,
                        smtp_from_email_rules: { isError: false }
                    });
                }, required: true, rules: this.state.smtp_from_email_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать SSL при подключении", value: this.state.smtp_use_ssl, onChecked: function (checked) {
                    _this.setState({ smtp_use_ssl: checked });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Использовать unisender", value: this.state.double_opt_in_via_unisender, onChecked: function (checked) {
                    _this.setState({ double_opt_in_via_unisender: checked });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Api ключ UniSender:", placeholder: "Введите api ключ UniSender" }, value: this.state.unisender_apikey, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_apikey: newVal,
                        unisender_apikey_rules: { isError: false }
                    });
                }, required: this.state.double_opt_in_via_unisender, disabled: !this.state.double_opt_in_via_unisender, rules: this.state.unisender_apikey_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Добавлять в unisender после верификации", value: this.state.is_unisender_add_on_verify_email, onChecked: function (checked) {
                    _this.setState({ is_unisender_add_on_verify_email: checked });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тег игрока в UniSender:", placeholder: "Введите тег игрока в UniSender" }, value: this.state.unisender_verify_email_player_tag, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_verify_email_player_tag: newVal,
                        unisender_verify_email_player_tag_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_add_on_verify_email, disabled: !this.state.is_unisender_add_on_verify_email, rules: this.state.unisender_verify_email_player_tag_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Id группы в UniSender:", placeholder: "Введите Id группы в UniSender" }, values: { max: 64000, min: 0, value: this.state.unisender_verify_email_player_group_id }, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_verify_email_player_group_id: newVal,
                        unisender_verify_email_player_group_id_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_add_on_verify_email, disabled: !this.state.is_unisender_add_on_verify_email, rules: this.state.unisender_verify_email_player_group_id_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Добавлять в unisender после подписки на новости", value: this.state.is_unisender_add_on_subscribe_email, onChecked: function (checked) {
                    _this.setState({ is_unisender_add_on_subscribe_email: checked });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тег игрока в UniSender:", placeholder: "Введите тег игрока в UniSender" }, value: this.state.unisender_subscribe_email_player_tag, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_subscribe_email_player_tag: newVal,
                        unisender_subscribe_email_player_tag_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_add_on_subscribe_email, disabled: !this.state.is_unisender_add_on_subscribe_email, rules: this.state.unisender_subscribe_email_player_tag_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Id группы в UniSender:", placeholder: "Введите Id группы в UniSender" }, values: { max: 64000, min: 0, value: this.state.unisender_subscribe_email_player_group_id }, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_subscribe_email_player_group_id: newVal,
                        unisender_subscribe_email_player_group_id_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_add_on_subscribe_email, disabled: !this.state.is_unisender_add_on_subscribe_email, rules: this.state.unisender_subscribe_email_player_group_id_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Добавлять mail адреса в отдельную группу", value: this.state.is_unisender_move_mail_players_to_another_group, onChecked: function (checked) {
                    _this.setState({ is_unisender_move_mail_players_to_another_group: checked });
                } }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Тег игрока в UniSender:", placeholder: "Введите тег игрока в UniSender" }, value: this.state.unisender_mail_payers_another_group_tag, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_mail_payers_another_group_tag: newVal,
                        unisender_mail_payers_another_group_tag_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_move_mail_players_to_another_group, disabled: !this.state.is_unisender_move_mail_players_to_another_group, rules: this.state.unisender_mail_payers_another_group_tag_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Id группы в UniSender:", placeholder: "Введите Id группы в UniSender" }, values: { max: 64000, min: 0, value: this.state.unisender_mail_players_another_group_id }, onValueChanged: function (newVal) {
                    _this.setState({
                        unisender_mail_players_another_group_id: newVal,
                        unisender_mail_players_another_group_id_rules: { isError: false }
                    });
                }, required: this.state.is_unisender_move_mail_players_to_another_group, disabled: !this.state.is_unisender_move_mail_players_to_another_group, rules: this.state.unisender_mail_players_another_group_id_rules }),
            React.createElement(CardRowButtonSet_1.default, { editMode: true, title: { btnEdit: "Сохранить", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandSmtpCfgEditor;
}(React.Component));
exports.default = BrandSmtpCfgEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandSmtpCfgEditor.tsx
// module id = 1811
// module chunks = 0